$(function() {

  if($(".slideshow[gtm-event='click_home_firstbanner1']").length){
    $(".slideshow[gtm-event='click_home_firstbanner1'] a").click(function() {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_home_firstbanner1",
        cus_params: {
            position: $(this).parents('.carousel__slide').index() + 1,
        }
      });
    });
  }

  window.gtmcarouselbtn = function(that) {
    if(that.parents('div[gtm-event="click_home_collection"]').length){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_home_collection_arrow",
        cus_params: {
          
        }
      });
    }
  }

  if($('div[gtm-event="click_home_collection_custom"]').length){
    $(document).on('click', 'div[gtm-event="click_home_collection_custom"] .slider-grid__slide a', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_home_collection_custom',
        cus_params: {
          display_id: $(this).parents('.slider-grid__slide').attr('gtm-media-id'),
          position: $(this).parents('.slider-grid__slide').attr('gtm-index'),
          button_name: $(this).attr('gtm-type'),
        }
      });
    });
  }

  if($('div[gtm-event="click_home_collection"]').length){
    $(document).on('click', 'div[gtm-event="click_home_collection"] .product-card .product-card__images-wrapper a', function () {
      gtm_click_home_collection($(this), 'item_image');
    });
    $(document).on('click', 'div[gtm-event="click_home_collection"] .product-card a.product-card__title', function () {
      gtm_click_home_collection($(this), 'item_name');
    });
    $(document).on('click', 'div[gtm-event="click_home_collection"] .product-card .gtm-quickview-btn', function () {
      gtm_click_home_collection($(this), 'quickview');
    });
    $(document).on('click', 'div[gtm-event="click_home_collection"] .product-card product-form .add-to-cart', function () {
      gtm_click_home_collection($(this), 'add_to_cart');
    });
    function gtm_click_home_collection(that, btnname){
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_home_collection',
        cus_params: {
          id: that.parents('product-card').attr('data-id'),
          price: Currency_Price_Format(that.parents('product-card').attr('data-price')),
          position: that.parents('.slider-grid__slide').index() + 1,
          button_name: btnname,
        }
      });
    }
    $(document).on('click', 'div[gtm-event="click_home_collection"] .collection-card__link', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_home_collection_viewall",
        cus_params: {
          
        }
      });
    });
  }
  
  if($(".collection[gtm-event='click_collection_hotsale_item']").length){
    $(".collection[gtm-event='click_collection_hotsale_item'] .collection-card__link").click(function() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "click_collection_hotsale_viewall",
          cus_params: {
            collection_name: $(this).parents(".collection[gtm-event='click_collection_hotsale_item']").attr('gtm-collection-name'),
          }
        });
    });
  }

  if($('div[gtm-event="click_shop_by_look"]').length){
    $(document).on('click', 'div[gtm-event="click_shop_by_look"] .slider-grid__slide a', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_shop_by_look',
        cus_params: {
          display_id: $(this).parents('.slider-grid__slide').attr('gtm-media-id'),
          position: $(this).parents('.slider-grid__slide').attr('gtm-index'),
        }
      });
    });
  }
  
  if($('div[gtm-event="click_home_blogs"]').length){
    $(document).on('click', 'div[gtm-event="click_home_blogs"] .slider-grid__slide a', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_home_blogs',
        cus_params: {
          display_id: $(this).parents('.slider-grid__slide').attr('gtm-id'),
          position: $(this).parents('.slider-grid__slide').attr('gtm-index'),
        }
      });
    });
  }
  
  if($('div[gtm-event="click_home_trustpilot"]').length){
    $(document).on('click', 'div[gtm-event="click_home_trustpilot"] a', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_home_trustpilot',
      });
    });
  }
  
  if($('div[gtm-event="click_home_instagram"]').length){
    $(document).on('click', 'div[gtm-event="click_home_instagram"] .instagram__title__bd a', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_home_instagram_follow',
      });
    });
    $(document).on('click', 'div[gtm-event="click_home_instagram"] .slider-grid__slide a', function () {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'click_home_instagram',
        cus_params: {
          display_id: $(this).parents('.slider-grid__slide').attr('gtm-media-id'),
          position: $(this).parents('.slider-grid__slide').attr('gtm-index'),
        }
      });
    });
  }
})